import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { push } from 'redux-first-history';
import { getUrlParams, getUrlString, updateSearchObject } from '../../../utils/shared/urlUtils';
import ProbeDetailsPage from '../../../features/probeDetails/shared/ProbeDetailsPage';
import { getRunningGirlsParams } from '../../../features/probeDetails/shared/runningGirlHelper';
import { getAssessorId } from '../../../utils/shared/probeDetailUtils';
import probeDetailLookerEvent from '../../../api/lrs/shared/lrsActions';
import {
    getProbeDetailsAssessmentName,
    getProbeDetailsHelpUrl,
    getProbeDetailsMeasureName,
    getProbeDetailsOverallScore,
} from '../../../utils/reading/probeDetailUtils';
import { getDetailedMeasureNameTwoLines } from '../../../utils/shared/measureUtils';
import { getRatesSection } from '../../../features/probeDetails/reading/runningGirlHelper';
import ProbeDetailsRenderBody from '../../../features/probeDetails/reading/ProbeDetailsRenderBody';
import { selectors } from '../../../root/reading/root';
import fetchStaff from '../../../api/staff/reading/staffActions';
import getAssessmentDate from '../../../utils/reading/probeDetailsPageUtils';
import {
    ALL_MEASURES,
    AVAILABLE_TITLE_MEASURE,
    MEASURE,
    PARENT_MEASURES,
} from '../../../constants/reading/MeasuresConstants';
import {
    HOW_TO_UNDERSTAND,
    PERIOD,
    PROBE_SIDE_PANEL,
} from '../../../constants/shared/CommonConstants';
import { NOT_SCORED } from '../../../constants/reading/TroConstants';
import { GRADE } from '../../../constants/shared/GradesConstants';
import {
    invalidateD8Result,
    invalidateMazeOnlineResult,
} from '../../../api/results/reading/resultActions';
import { D8_MEASURES } from '../../../constants/shared/MeasuresConstants';
import { INVALIDATE_D8_RESULT } from '../../../api/actionTypes/reading/apiActionTypes';

const { TRC, TRO } = MEASURE;

const mapStateToProps = (state, ownProps) => {
    const result = selectors.getResultById(state, ownProps.resultId);
    const location = selectors.getLocation(state);
    const { studentId, measure, grade, period, measureScores, measureResult } = result;
    const student = selectors.getStudentById(state, studentId);
    const isUntranscribable = get(result, 'isUntranscribable', false);
    const overallScore = getProbeDetailsOverallScore(result);
    const overallStatus = !isUntranscribable ? get(measureResult, 'interpretation') : NOT_SCORED;
    const overallField = {
        overallLabel: overallScore ? 'Overall Score' : 'Overall Status',
        overallValue: overallScore || overallStatus,
    };
    const isDemoModeOn = selectors.getIsDemoModeOn(state);
    const isReadingComprehension = measure === TRC || measure === TRO;
    const assessmentName = isReadingComprehension
        ? getDetailedMeasureNameTwoLines(ALL_MEASURES, measure)
        : getProbeDetailsAssessmentName(measure);
    const currentSubtab = getUrlParams(location)?.progressView || '';
    const isGuidedTourOn = selectors.getIsGuidedTourOn(state);

    const isDTCUser = selectors.getIsDTC(state);
    const isD8Measure = [...D8_MEASURES, ...PARENT_MEASURES].includes(result.measure);
    const isResultInEoyWithAllowedGrades =
        result.period === PERIOD.EOY &&
        [GRADE.KINDERGARTEN, GRADE.FIRST_GRADE, GRADE.SECOND_GRADE, GRADE.THIRD_GRADE].includes(
            result.grade,
        );
    const isResultInSummerWithAllowedGrades =
        result.period === PERIOD.SUMMER && [GRADE.THIRD_GRADE].includes(result.grade);

    const isInvalidationFeatureAvailable =
        isDTCUser && isD8Measure
            ? isResultInEoyWithAllowedGrades || isResultInSummerWithAllowedGrades
            : false;

    return {
        result,
        student,
        overallField,
        assessmentName,
        location,
        staff: isDemoModeOn
            ? selectors.getDemoStaff(state)
            : selectors.getStaffById(state, getAssessorId(result)),
        isStaffFetching: selectors.isStaffFetching(state),
        howToUnderstandText: HOW_TO_UNDERSTAND.ASSESSMENT,
        assessmentDate: getAssessmentDate(result, location),
        helpUrl: getProbeDetailsHelpUrl(measure, selectors.getLicensingInfo(state)),
        runningGirlsParams: getRunningGirlsParams(
            selectors.getInterps(state),
            grade,
            period,
            measureScores,
            getRatesSection,
            getProbeDetailsMeasureName,
            AVAILABLE_TITLE_MEASURE,
        ),
        className: `${PROBE_SIDE_PANEL} ${isDemoModeOn ? ' in-demo' : ''}`,
        currentSubtab,
        isGuidedTourOn,
        isInvalidationFeatureAvailable,
        summerPeriodLabel: selectors.getSummerPeriodLabel(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchStaff: assessorId => dispatch(fetchStaff(assessorId)),
        closeComponent: location => {
            dispatch(
                push(
                    getUrlString(location.pathname, {
                        ...updateSearchObject(location, ['resultId', 'bookId', 'tab']),
                    }),
                ),
            );
        },
        pdLookerEvent: (measure, studentId, currentSubtab) =>
            dispatch(probeDetailLookerEvent(measure, studentId, currentSubtab)),

        invalidateResult: result => {
            dispatch({
                type: INVALIDATE_D8_RESULT.START,
            });
            if (result.measure === MEASURE.MAZE) {
                dispatch(invalidateMazeOnlineResult(result));
            } else {
                dispatch(invalidateD8Result(result));
            }
        },
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { student, result, currentSubtab } = stateProps;
    const { pdLookerEvent } = dispatchProps;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        body: (
            <ProbeDetailsRenderBody
                measure={result.measure}
                student={student}
                result={result}
                probeDetailLookerEvent={pdLookerEvent}
                currentSubtab={currentSubtab}
            />
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProbeDetailsPage);
